export default class wdkHintbox extends HTMLElement {
	connectedCallback() {
		this.#hideHintBoxIfPersisted();
		this.#renderHTML();
		this.#initHintboxOnConnect();
	}

	static get observedAttributes() {
		return ['hidden'];
	}

	attributeChangedCallback(name) {
		if (name === 'hidden') {
			this.#fillA11yWrapper();
		}
	}

	#hideHintBoxIfPersisted() {
		this.storageNameSpaceKey = this.getAttribute('storageNameSpaceKey');
		this.storageCategoryKey = this.getAttribute('storageCategoryKey');

		if (this.storageNameSpaceKey !== null && this.storageCategoryKey !== null) {
			const isSeen = jPar.app?.appState?.get('localStorage', this.storageNameSpaceKey, this.storageCategoryKey);
			if (isSeen === true) {
				this.hide();
			}
		}
	}

	#renderHTML() {
		const myHtml = `<style>
					:host {
						display: flex;
						flex-shrink: 0;
						gap: 8px;
						margin-top: 8px;
						margin-bottom: 10px;
						align-items: center;
						position: relative;
						color: var(--COLOR_support_white_default);
						font: var(--FONT_default_75);
						border-radius: var(--RADIUS_S);
						padding: 14px;
						height: auto;
						max-height: 350px; 
						opacity: 1;
					}
					
					:host(.closeingAnimation) {
						transform-origin: top left;
						transition: opacity .3s ease-out, max-height .3s ease-out, padding-top .3s ease-out, padding-bottom .3s ease-out; 
					}
					
					:host([hidden]) {
						display: flex !important; /* muss hier leider überschrieben werden */
						opacity: 0;
						max-height: 0;
						margin: 0;
						padding-top: 0;
						padding-bottom: 0;
					}
					
					:host([skin="success"]) {
						background-color: var(--COLOR_alert_success_default);
						color: var(--COLOR_support_white_default);
						overflow: hidden;
					}

					:host([skin="warning"]) {
						background-color: var(--COLOR_alert_warning_default);
						color: var(--COLOR_support_white_default);
						overflow: hidden;
					}

					:host([skin="info"]) {
						background-color: var(--COLOR_alert_info_default);
						color: var(--COLOR_support_white_default);
						overflow: hidden;
					}

					:host([skin="info2"]) {
						background-color: var(--COLOR_alert_info_light);
    					color: var(--COLOR_alert_info_default);
						overflow: hidden;
					}

					:host([skin="info3"]) {
						background-color: var(--COLOR_gray_500);
						color: var(--COLOR_gray_100);
						overflow: hidden;
					}
					
					:host([skin="healthyDating"]) {
						display: flex;
						align-items: center;
						padding: 16px;
						color: var(--COLOR_defaultText);
						border: 2px solid var(--COLOR_primary_default); 
				
						img {
							margin-right: 8px;
						}
				
						a {
							color: var(--COLOR_defaultText) !important;
						}
					}

					:host a {
						color: currentColor;
						text-decoration: underline;
					}

					:host h3 {
						font: var(--FONT_default_50);
						text-transform: uppercase;
						margin: 0 0 4px 0;
					}

					:host button {
						position: relative;
						border: none;
						background: transparent;
						cursor: pointer;
						align-self: flex-start;
    					margin: 0;
    					padding: 0;
    					width: 18px;
    					height: 18px;
					}
					
					:host button:focus-visible {
						outline: 2px dashed currentColor;
						outline-offset: 10px;
					}

					:host button:after {
						content: "";
    					position: absolute;
    					top: 50%;
    					left: 50%;
    					transform: translate(-50%, -50%);
    					height: 48px;
    					width: 48px;
					}

					:host button:hover {
						opacity: .7;
					}

					:host button svg {
						width: 16px;
						height: 16px;
						fill: var(--COLOR_gray_100);
					}
				
					::slotted([slot="icon"].wdk-icon) {
						width: 22px !important;
						height: 22px !important;
						min-width: 22px;
						fill: currentColor !important;
					}

					#a11yWrapper {
						flex-grow: 1;
					}

					.wdkA11yRepeat {
						position:absolute;
						left:-9999px;
						width: 1px;
						height: 1px;
					}
				</style>
				<slot name="icon"></slot>
				<div id="a11yWrapper" aria-live="assertive" role="alert" aria-atomic="true"></div>
				${this.#getCloseButton()}
			`;
		this.shadowTemplate = document.createElement('template');
		this.shadowTemplate.innerHTML = jPar.wdk.security.sanitizeEvilHtml(myHtml);
	}

	#initHintboxOnConnect() {
		const clone = document.importNode(this.shadowTemplate.content, true);

		if (!this.shadowRoot) {
			this.attachShadow({ mode: 'open' });
			this.shadowRoot.appendChild(clone);
			this.#fillA11yWrapper();
		}

		this.shadowRoot.querySelector('.js-close')?.addEventListener('click', () => {
			this.hide();
		});
	}

	#getCloseButton() {
		if (this.getAttribute('closable') !== null) {
			return `<button part="base" class="js-close" type="button" role="button" aria-disabled="false" aria-label="Close" tabindex="0">
        			<svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24" height="24" viewBox="0 0 24 24">
						<path id="icon_x-a" fill-rule="evenodd" clip-rule="evenodd" d="M19.7044 18.2864C19.8936 18.4741 20 18.7295 20 18.996C20 19.2624 19.8936 19.5179 19.7044 19.7055C19.5168 19.8947 19.2614 20.0011 18.9949 20.0011C18.7285 20.0011 18.4731 19.8947 18.2854 19.7055L12 13.4194L5.71456 19.7055C5.52692 19.8947 5.27151 20.0011 5.00507 20.0011C4.73863 20.0011 4.48321 19.8947 4.29558 19.7055C4.10641 19.5179 4 19.2624 4 18.996C4 18.7295 4.10641 18.4741 4.29558 18.2864L10.581 12.0003L4.29558 5.71418C3.90375 5.3223 3.90375 4.68693 4.29558 4.29505C4.68742 3.90317 5.32272 3.90317 5.71456 4.29505L12 10.5812L18.2854 4.29505C18.6773 3.90317 19.3126 3.90317 19.7044 4.29505C20.0963 4.68693 20.0963 5.3223 19.7044 5.71418L13.419 12.0003L19.7044 18.2864Z"/>
					</svg>
      			</button>
				`;
		} else {
			return '';
		}
	}

	#fillA11yWrapper() {
		const lightClone = document.importNode(this.querySelector('template').content, true);

		if (this.shadowRoot !== null && this.hasAttribute('hidden') === false) {
			this.shadowRoot.querySelector('#a11yWrapper').innerHTML = '';
			this.shadowRoot.querySelector('#a11yWrapper').appendChild(lightClone);

			this.#triggerA11yRepeat();
			this.#handleShow();
		}
	}

	#handleShow() {
		if (this.hasAttribute('hidden') === false) {
			this.removeAttribute('inert');

			this.dispatchEvent(
				new CustomEvent('wdk-hintbox', {
					bubbles: true,
					detail: { state: 'shown', element: this },
				}),
			);
		}
	}

	show() {
		this.removeAttribute('hidden');
	}

	hide() {
		this.classList.add('closeingAnimation');
		this.addEventListener(
			'transitionend',
			function () {
				this.classList.remove('closeingAnimation');
			},
			{ once: true },
		);

		this.setAttribute('hidden', '');
		this.setAttribute('inert', 'true');

		if (this.storageNameSpaceKey !== null && this.storageCategoryKey !== null) {
			jPar.app?.appState?.set('localStorage', this.storageNameSpaceKey, this.storageCategoryKey, true);
		}

		this.dispatchEvent(
			new CustomEvent('wdk-hintbox', {
				bubbles: true,
				detail: { state: 'hidden', element: this },
			}),
		);
	}

	#triggerA11yRepeat() {
		window.setTimeout(() => {
			const myDiv = document.createElement('div');
			myDiv.classList.add('wdkA11yRepeat');
			myDiv.innerText = '!';
			this.shadowRoot.querySelector('#a11yWrapper').appendChild(myDiv);
		}, 200);
	}

	isVisible() {
		return this.getAttribute('hidden') === 'false';
	}
}
